<div class='hvac-tooltip-anchor-content'><ng-content></ng-content></div>
